import React, {FC} from "react";
import {useIntl} from "react-intl";
import PaymentRequest from "./PaymentRequest";
import { PageTitle } from "../../../../_metronic/layout/core";

const PaymentRequestWrapper: FC = () => {
  const intl = useIntl();
  const breadcrumbs = [
    {
      title: intl.formatMessage({id: 'MENU.DASHBOARD'}),
      path: '/dashboard',
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    }
  ]

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Yêu cầu thanh toán</PageTitle>
      <PaymentRequest/>
    </>
  )
}
export default PaymentRequestWrapper;